import classnames from 'classnames';
import React from 'react';
import { User } from '../../clients/aasServerClient.generated';
import Random from '../../helpers/random';
import './UserImage.scss';

// tslint:disable-next-line:no-any
interface Props extends React.HTMLAttributes<HTMLDivElement> {
    user?: User;
    size: 's' | 'm' | 'l';
}

const UserImage: React.SFC<Props> = ({ user, size, className, ...rest }) => {

    if (user === undefined) {
        return (
            <div
                style={{ backgroundColor: '#444' }}
                className={classnames(className, `profile-circle-${size}`)}
                {...rest}
            />
        );
    }

    let initials = '';
    if (user.first_name) {
        initials = user.first_name.charAt(0);
    }
    if (user.last_name) {
        initials += user.last_name.charAt(0);
    }
    if (initials === '') {
        initials += (user.username || user.email || '?').charAt(0);
    }

    const rand = new Random(Random.hashString(user.id));
    const colors = [
        '#3f85cd',
        '#3fadcd',
        '#853fcd',
        '#c13fcd',
        '#cd3f74',
        '#cd3f3f',
        '#cd6a3f',
        '#3fcd6a',
    ];
    const imgStyle = {
        backgroundColor: colors[rand.next() % colors.length],
    };

    return (
        <div style={imgStyle} className={classnames(className, `profile-circle-${size}`)} {...rest}>
            {initials.toUpperCase()}
        </div>
    );
};

export default UserImage;